import { AccountResponse, CustomerFeature } from '@forto-dev/customer-master-data-models'

export type Customer = {
  _id: string
  name: string
  enabledFeatures: CustomerFeature[]
  segment: string | null
  assignees?: {
    sales?: {
      email?: string
    }
  }
  activatedAt?: Date
  deactivatedAt?: Date
}

export function customerHasFeature(customer: Customer, feature: CustomerFeature): boolean {
  return !!customer.enabledFeatures && customer.enabledFeatures.indexOf(feature) > -1
}

export const mapAccountResponseToCustomer = (account: AccountResponse): Customer => {
  return {
    _id: account._id,
    name: account.name,
    enabledFeatures: account.enabledFeatures ?? [],
    segment: account.segment,
    assignees: account.assignees,
    activatedAt: account.activatedAt ? new Date(account.activatedAt) : undefined,
    deactivatedAt: account.deactivatedAt ? new Date(account.deactivatedAt) : undefined,
  }
}
